import React, { useEffect } from "react";
import Card from "components/card";
import ActivityCard from "./ActivityCard";
import { Sparkles } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getMyRewardSummary } from "../../../../../redux/employeereward/employeeRewardState";

const HyvidPoints = ({ }) => {
  const dispatch = useDispatch()
  const myRewardSummary = useSelector((state) => state.employeeReward.myRewardSummary);

  useEffect(() => {
    dispatch(getMyRewardSummary());
  }, [dispatch]);

  const recordList = myRewardSummary?.data || { balance: 0, percentile: 0, activities: [] };

  const balance = recordList.balance ?? 0;
  const percentile = recordList.percentile ?? 0;
  const activities = Array.isArray(recordList.activities) ? recordList.activities : [];

  return (
    <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200 dark:border-purple-700">
      <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
        <h4 className="leading-none flex items-center gap-2 title-text">
          <Sparkles className="w-5 h-5 text-purple-600 dark:text-purple-500" />
          Hyvid Points
        </h4>
        <p className="muted-text">Your Hyvid Rewards program</p>
      </div>

      <div className="px-6 pb-6">
        <div className="space-y-6">
          <div className="flex flex-col gap-6 rounded-2xl border-2 border-purple-300 dark:border-purple-800 bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-900 dark:to-pink-900">
            <div className="p-6 text-center">
              <Sparkles className="w-12 h-12 mx-auto mb-3 text-purple-600 dark:text-purple-100" />
              <p className="text-sm mb-2 muted-text">Your Balance</p>
              <p className="text-4xl font-bold text-purple-600 mb-2 dark:text-purple-400">{balance.toLocaleString()}</p>
              {percentile > 0 && (
                <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap border-transparent bg-purple-600 text-white">
                  Top {percentile}% Rank
                </span>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-3 title-text">Recent Activity</h4>
            <div className="space-y-2">
              {activities.length > 0 ? (
                activities.map((item, index) => (
                  <ActivityCard
                    key={index}
                    title={item?.title ?? ""}
                    date={item?.date ?? ""}
                    points={item?.points ?? ""}
                  />
                ))
              ) : (
                <p className="text-sm muted-text">No reward data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default HyvidPoints;